module.exports = __webpack_public_path__ + "img/4.5b4c38c7.png";